<template>
  <v-snackbar
    v-model="showSuccess"
    :timeout="timeout"
  >
    <div class="d-flex align-center">
      <v-icon  class="mr-3" large color="success">mdi-check-outline</v-icon>
      <v-spacer></v-spacer>
      <div class="">{{ message }}</div>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SuccessSnackBar',
  props: ['message', 'timeout'],
  data: () => ({
    showSuccess: true
  }),
  watch: {
    showSuccess: function (newValue, oldValue) {
      if (!newValue) {
        this.$store.commit('setSuccessMessage', '')
      }
    }
  }
}
</script>

<style scoped>

</style>
